import { useCallback, useEffect, useState } from 'react';

import { useAuth, useEventfy, useToggle } from '@hooks';
import { selectIsSatisfactionSurveyEnabled } from '@hooks/useEventfy/selectors';
import { selectUser } from '@hooks/useAuth/selectors';

export const useLayoutModals = () => {
  const user = useAuth(selectUser);
  const isSurveyEnabled = useEventfy(selectIsSatisfactionSurveyEnabled);

  const [isSurveyModalVisible, toggleIsSurveyModalVisible] = useToggle(false);
  const [isCertificateModalVisible, toggleIsCertificateModalVisible] =
    useToggle(false);
  const [isMobileMenuVisible, toggleIsMobileMenuVisible] = useToggle(false);
  const [isUserMobileMenuVisible, toggleIsUserMobileMenuVisible] =
    useToggle(false);
  const [isProfileModalVisible, toggleIsProfileModalVisible] = useToggle(false);
  const [isIndicationsModalVisible, toggleIsIndicationsModalVisible] =
    useToggle(false);

  const [isSurveyNoticeVisible, setIsSurveyNoticeVisible] = useState(
    !user.survey_replied && isSurveyEnabled,
  );

  const closeSurveyNotice = useCallback(
    () => setIsSurveyNoticeVisible(false),
    [],
  );

  useEffect(() => {
    if (isSurveyModalVisible && !isSurveyEnabled) {
      toggleIsSurveyModalVisible();
    }
  }, [isSurveyModalVisible, isSurveyEnabled, toggleIsSurveyModalVisible]);

  useEffect(() => {
    setIsSurveyNoticeVisible(isSurveyEnabled);
  }, [isSurveyEnabled]);

  useEffect(() => {
    if (isSurveyNoticeVisible && !!user.survey_replied) {
      closeSurveyNotice();
    }
  }, [isSurveyNoticeVisible, user.survey_replied, closeSurveyNotice]);

  return {
    // Survey
    isSurveyEnabled,
    isSurveyModalVisible,
    toggleIsSurveyModalVisible,
    isSurveyNoticeVisible,
    closeSurveyNotice,
    // Certificate
    isCertificateModalVisible,
    toggleIsCertificateModalVisible,
    // Mobile menus
    isMobileMenuVisible,
    toggleIsMobileMenuVisible,
    isUserMobileMenuVisible,
    toggleIsUserMobileMenuVisible,
    // Profile
    isProfileModalVisible,
    toggleIsProfileModalVisible,
    // Indications
    isIndicationsModalVisible,
    toggleIsIndicationsModalVisible,
  };
};
